import type {SkuType} from '@github-ui/copilot-chat-helpers/sku-types'
import {sendEvent} from '@github-ui/hydro-analytics'
import {Banner} from '@primer/react'

import {SKU_BANNER_CONFIGS} from './config'
import type {SkuSuccessBannerProps} from './types'

interface SkuSuccessBannerComponentProps extends SkuSuccessBannerProps {
  skuType: SkuType
}

export function SkuSuccessBanner({skuType, onDismiss, className}: SkuSuccessBannerComponentProps) {
  const config = SKU_BANNER_CONFIGS[skuType]

  // Guard for type-checking
  if (!config) return null

  return (
    <div className={className}>
      <Banner
        variant="success"
        title={config.title}
        description={config.description}
        hideTitle
        onDismiss={() => {
          onDismiss()
          sendEvent('dotcom_chat.activate', {
            target: config.dismissTarget,
            mode: 'immersive',
          })
        }}
      />
    </div>
  )
}
